import Header from '@/components/Header';
import PhoneConsultation from '@/components/PhoneConsultation';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';

const PhoneConsultationPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <SEO
        title="Phone Consultation | Freeman & Crown Law"
        description="Schedule a professional phone consultation with our constitutional law experts. Get legal guidance on tax law, constitutional matters, and securities law."
        image="/lovable-uploads/71fa2df8-9429-454b-a2ba-604271a8b424.png"
        url={window.location.origin + '/phone-consultation'}
        type="website"
      />
      <PhoneConsultation />
      <Footer />
    </div>
  );
};

export default PhoneConsultationPage;